import { Api } from './Api';

export function* getLocatonData(city){
    const jsonData = yield Api.get(`/locationpage?region=${city}`);
    return jsonData;
}